import script from "./RicetteTable3.vue?vue&type=script&setup=true&lang=js"
export * from "./RicetteTable3.vue?vue&type=script&setup=true&lang=js"

import "./RicetteTable3.vue?vue&type=style&index=0&id=1e4b7a65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4b7a65"]])

export default __exports__